import { useMemo } from "react";

export const useFormatedText = (text) => {
    const preparedDescription = useMemo(() => {
        if (!text) {
            return null;
        }

        const strWithSeparateLinks = text.replace(/\Bhttps?:\/\/|\Bwww\.\w+\./g, ' $&');
        const reg = /https?:\/\/\S+|www\.\S+/g;
        const links = strWithSeparateLinks.match(reg);
        const splittedString = strWithSeparateLinks.split(reg);
        const result = [];
        splittedString.forEach((str, i) => {
            result.push(str);
            
            if (links?.[i]) {
                const href = links[i].startsWith('www')
                    ? `https://${links[i]}`
                    : links[i];

                result.push((
                    <a
                        key={i}
                        href={href}
                        target='_blank'
                        rel="noreferrer"
                        style={{ wordBreak: 'break-all' }}
                    >
                        {links[i]}
                    </a>
                ));
            }
        });
        return result;
    }, [text]);

    return preparedDescription;
}